import { useEffect, useState } from "react";
import { countdown } from "@/lib/format";

const TONE = {
    "on-track": "text-muted-foreground",
    "at-risk": "text-amber-300",
    breached: "text-red-400 sla-breached",
};

export default function SLACountdown({ deadline, status, compact = false }) {
    const done = status === "CLOSED" || status === "RESOLVED";
    const [tick, setTick] = useState(countdown(deadline));
    useEffect(() => {
        if (done) return;
        const t = setInterval(() => setTick(countdown(deadline)), 1000);
        return () => clearInterval(t);
    }, [deadline, done]);
    if (done) {
        return <span className="font-mono text-xs text-emerald-400">— done —</span>;
    }
    const tone = TONE[tick.state];
    return (
        <span
            data-testid="sla-countdown"
            className={`font-mono ${compact ? "text-xs" : "text-sm"} ${tone}`}
            title={tick.state}
        >
            {tick.label}
        </span>
    );
}
